/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

import { findIndex } from 'lodash-es';

import './CheckBoxesFilter.scss';

class CheckBoxesFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { values: [...props.values] };
  }

  handleChange = (event, checked) => {
    // eslint-disable-next-line react/prop-types
    const { name, onFilterChange } = this.props;
    const { values } = this.state;
    const { target } = event;
    const newValues = [...values];

    if (checked) {
      // add value at first
      if (newValues.indexOf(target.value) === -1) {
        newValues.unshift(target.value);
        this.setState({ values: newValues });
      }
    } else if (newValues.indexOf(target.value) > -1) {
      newValues.splice(newValues.indexOf(target.value), 1);
      this.setState({ values: newValues });
    }

    onFilterChange({ values: [...newValues], checked, name });
  };

  render() {
    const { name, options = [], label, classes } = this.props;
    const { values } = this.state;

    const isChecked = option => findIndex(values, value => value === option.value) > -1;
    return (
      <FormControl component="fieldset" className={classes.formControl}>
        <div className="form-label">{label}</div>
        <FormGroup>
          {options.map(option => (
            <FormControlLabel
              control={
                <Checkbox
                  value={option.value}
                  checked={isChecked(option)}
                  onChange={this.handleChange}
                  name={name}
                  className="filter-checkbox"
                />
              }
              label={option.label}
              key={`${name}-${option.value}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    );
  }
}
CheckBoxesFilter.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onFilterChange: PropTypes.func,
  values: PropTypes.arrayOf(PropTypes.string),
  classes: PropTypes.any.isRequired,
  options: PropTypes.any.isRequired,
};
CheckBoxesFilter.defaultProps = {
  onFilterChange: params => {
    // eslint-disable-next-line no-console
    console.log('CheckBoxes::onChange', params);
  },
  values: [],
  name: '',
  label: '',
};

export default CheckBoxesFilter;
